module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/AppStoreText-0c6cb2df66ecb58d50e2f11c81d785e2.svg";